import { useTranslation } from 'react-i18next';

export default function EntryRow({ entry, selected, onToggleSelect, onOpen }) {
  const { t } = useTranslation();
  // Prefer authors; for edited volumes (no authors) fall back to editors so the
  // card doesn't read "Unknown author".
  const authors =
    (entry.authors?.length && entry.authors.join(', ')) ||
    (entry.editors?.length && entry.editors.join(', ')) ||
    t('bibliography.unknownAuthor');

  return (
    <article className="card flex gap-4 px-5 py-4 cursor-default">
      <label className="flex shrink-0 items-start pt-1" onClick={(e) => e.stopPropagation()}>
        <input
          type="checkbox"
          checked={selected}
          onChange={() => onToggleSelect(entry.id)}
          className="h-4 w-4 cursor-pointer accent-gold"
          aria-label={t('bibliography.selectForExport')}
        />
      </label>

      <button
        type="button"
        onClick={() => onOpen(entry)}
        className="flex-1 cursor-pointer text-left"
      >
        <div className="mb-1 flex flex-wrap items-baseline gap-x-3 gap-y-1">
          <span className="text-[0.7rem] font-semibold uppercase tracking-[0.15em] text-gold">
            {t(`bibliography.types.${entry.type}`)}
          </span>
          {entry.year && (
            <span className="text-[0.8rem] text-ink-muted">{entry.year}</span>
          )}
          {entry.language_display && (
            <span className="text-[0.7rem] text-ink-muted">
              · {entry.language_display}
            </span>
          )}
        </div>

        <h3 className="font-serif text-lg font-semibold leading-snug text-cream">
          {entry.title}
        </h3>

        <p className="mt-1 text-sm text-ink-secondary">{authors}</p>

        {entry.journal && (
          <p className="mt-1 text-sm italic text-ink-secondary">
            {entry.journal}
            {entry.volume ? `, vol. ${entry.volume}` : ''}
            {entry.issue ? `, no. ${entry.issue}` : ''}
            {entry.pages ? `, pp. ${entry.pages}` : ''}
          </p>
        )}
        {entry.booktitle && (
          <p className="mt-1 text-sm italic text-ink-secondary">In {entry.booktitle}</p>
        )}

        {entry.keywords?.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-1.5">
            {entry.keywords.slice(0, 6).map((k) => (
              <span
                key={k}
                className="rounded-full border border-white/10 bg-navy-mid/40 px-2 py-0.5 text-[0.7rem] text-ink-secondary"
              >
                {k}
              </span>
            ))}
            {entry.keywords.length > 6 && (
              <span className="text-[0.7rem] text-ink-muted">
                +{entry.keywords.length - 6}
              </span>
            )}
          </div>
        )}
      </button>
    </article>
  );
}
